<template lang="pug">
div
  app-nav
  .row
    .col-sm-2
    .col-sm-10      
          h2 Liste de garde/astreinte 
          p Astreinte à partir du 1/1/2019...
  .row
    div(v-if="listeById")
      .col-sm-10.col-md-8.offset-2
        p {{moment(listeById.date).format('MMMM - YYYY')}}
        button(type="button" class='btn btn-primary pull-right my-4'  @click="imprimerPdf()") Imprimer PDF
        router-link(class="btn btn-primary my-4 ml-1" :to="{name: 'GardesEdit' , params: { id: listeById.id }}") Editer
        router-link(class="btn btn-primary my-4 ml-1" :to="{name: 'Gardes'} ") Retour
      
        table.table.table-striped
            tbody
                tr(v-if="listeById.joursByListeId" v-for="jour in listeById.joursByListeId.edges" :key="jour.node.id")
                    td {{moment(jour.node.date).format('dddd Do MMMM YYYY') }}
                    td
                        p(v-if="jour.node.titulaireByTitulaireId") {{jour.node.titulaireByTitulaireId.nom}}
                        p(v-else) --
        .col-xs-12.col-sm-4 
        p.lead= sidebar
    div(v-else)
        p Pas de liste de garde
  
</template>
<script>
import AppNav from './AppNav'
var R = require('ramda')
var us = require('underscore')
import { 
  ALL_TITULAIRES_QUERY,
  ACTIFS_TITULAIRES_QUERY
} from '../constants/graphql'
import { 
  GARDE_BY_ID_QUERY 
} from '../constants/gardes'
import { contentGardes } from '../assets/javascripts/gardes_print'
import { contentAstreintes} from '../assets/javascripts/astreintes_print'
import moment from 'moment'
moment.locale('fr')

export default {
  name: 'garde',
  components: {
    AppNav
  },
  data() {
    return {
      moment: moment,
      listeById: {},       
      allTitulaires: []   
    }
  },
  apollo: {
      listeById: {
        query: GARDE_BY_ID_QUERY,
        variables() {
          var id = parseInt(this.$route.params.id,10)
          return{
            id
          }
        },
        fetchPolicy: 'cache-and-network',
      },
        allTitulaires: {
      query: ACTIFS_TITULAIRES_QUERY
    }
  },
  methods: {
    renderListe (listes, titulaires, tbyMonth) {
      var bcontent
      if (moment(listes.date).isAfter('2018-12-31')) {
        bcontent = contentAstreintes
      } else {
        bcontent = contentGardes
      }
      var docDefinition = {
        pageSize: 'A4',
        content: bcontent(titulaires, listes, tbyMonth),
        pageMargins: [15, 10, 0, 0],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          table1: {
            fontSize: 8
          },
          table2: {
            bold: true
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          },
          defaultStyle: {
            // font: 'Times'
          }
        }
      }
      this.$pdfmake.createPdf(docDefinition).download('liste_de_garde.pdf')
    },
    imprimerPdf() {           
      var tbyMonth =  this.getTitulaireByMonth(this.listeById)
      this.renderListe(this.listeById, this.allTitulaires, tbyMonth)
    },
    // @input: the id of a list
    // @output: a key value object with the id of the titulaire and the number of gardes in the month
    getTitulaireByMonth(_listeById) {
      var  lot =_listeById.joursByListeId.edges.map(function(jour){
          return jour.node.titulaireByTitulaireId
      });
      var containTbm = R.pluck('id',lot)
      var ln = R.map(x => 0, containTbm)
      containTbm = R.zipObj(containTbm, ln)
      _listeById.joursByListeId.edges.forEach(function(jour) {
          if (jour.node.titulaireByTitulaireId) {
              if (moment(jour.node.date).day() === 0 || moment(jour.node.date).isFerie()) { //TODO mettre les dates françaises
                  if (us.contains(Object.keys(containTbm), String(jour.node.titulaireByTitulaireId.id))) {
                      containTbm[jour.node.titulaireByTitulaireId.id] += 2
                  }
              } else {
                  if (us.contains(Object.keys(containTbm), String(jour.node.titulaireByTitulaireId.id))) {
                      containTbm[jour.node.titulaireByTitulaireId.id] += 1
                  }
              }
          }
      })
      return us.omit(containTbm, 'undefined')
    }
  }
}
</script>
<style scoped>
table td{
 width: 20rem;
}
</style>





// WEBPACK FOOTER //
// garde.vue?2b0d07fb